import React from 'react';
import { StyledPensionPlanLanding } from './styles';
import Island from '../shared/Island';
import Navbar from '../shared/Navbar';
import styled from 'styled-components';
import { flexCenter, flexColumn, breakpoints } from '../../constants/styles';
import Title from '../shared/Title';
import Text from '../shared/Text';
import Footer from '../landing/Footer';
import FloatingContact from '../shared/FloatingContact';
import PensionPlanCTA from '../landing/PensionPlanCTA';
import VideoPlayer from '../PilarPages/VideoPlayer';
import { StyledCustomHr } from '../landing/ReferralLanding';
import Section from '../landing/Section';

const StyledSection = styled.div`
  ${flexCenter}
`;

const StyledPdf = styled.img`
  width: 70%;
  height: auto;
  margin-top: 20px;
  ${breakpoints.tablet} {
    width: 30%;
  }
`;

const StyledContent = styled.div`
  margin-top: 60px;
  ${flexColumn}
  justify-content: center;
  align-items: center;
  padding: 20px;
  ${breakpoints.tabletLandscape} {
    margin-top: 80px;
  }
`;

const StyledCTAButtonsContainer = styled.div`
  ${flexCenter}
  flex-direction: column;
`;

const StyledVideoContainer = styled.div`
  width: 60%;
`;

const VideoPlayerContainer = styled.div`
  margin-top: 10px;
  align-self: center;
  margin-bottom: 20px;
  width: 280px;

  ${breakpoints.tablet} {
    margin-bottom: 30px;
    width: 500px;
  }

  ${breakpoints.desktop} {
    margin-bottom: 40px;
    width: 650px;
  }
`;

export default function index() {
  return (
    <StyledPensionPlanLanding>
      <Navbar />
      <StyledContent>
        <Title level={2} style={{ marginRight: '20px' }}>
          Plan de pensión
        </Title>
        <StyledSection>
          <StyledPdf src="https://finauta.s3.us-east-2.amazonaws.com/products/pdf-preview.png" />
        </StyledSection>
        <Text type="body2">Con base en tu situación, tu plan incluye:</Text>
        <ul>
          <li>
            <Text type="body2">
              Cálculo detallado de <b>con cuánto te retirarás</b> si sigues como vas
            </Text>
          </li>
          <li>
            <Text type="body2">
              Cálculo detallado de 3 escenarios dentro de <b>modalidad 40</b>
            </Text>
          </li>
          <li>
            <Text type="body2">Análisis de costo/beneficio de modalidad 40</Text>
          </li>
          <li>
            <Text type="body2">Riesgos y áreas de oportunidad de tu situación</Text>
          </li>
        </ul>
        <PensionPlanCTA origin="PensionPlanLanding" />
        <StyledCustomHr />
        <Section>
          <Title level={3} style={{ marginBottom: '20px' }}>
            ¿Qué es un plan de pensión?
          </Title>
          <VideoPlayerContainer>
            <VideoPlayer url="https://www.youtube.com/watch?v=KwkyvILxRpI" />
          </VideoPlayerContainer>
        </Section>
      </StyledContent>
      <FloatingContact />
      <Footer />
    </StyledPensionPlanLanding>
  );
}
